<template>
  <CModal
    v-if="showModal"
    :show.sync="showModal"
    :no-close-on-backdrop="true"
    :centered="true"
    title="Modal title 2"
    size="lg"
    class="doctor-list-modal small-table-padding modal-width"
  >
    <div v-if="doctor && doctor.registration_proof_image_url" class="text-center">
      <image-view
        :zoomImg="true"
        :src="doctor.registration_proof_image_url"
        v-if="checkIfImage(doctor.registration_proof_image_url)"
      ></image-view>
      <pdf-component
        :src="doctor.registration_proof_image_url"
        :styles="'width: 100%; height: 800px'"
        v-else
      ></pdf-component>
    </div>
    <div v-if="doctor.current_document_status == 'NOT_UPLOADED'">
      <h2>Certificate not uploaded !</h2>
    </div>
    <div class="mt-4" v-if="doctor.current_document_status == 'REJECT'">
      <p class="mb-0">
        <b>Reason</b>
      </p>
      <p v-html="doctor.rejected_details.rejected_reason"></p>
    </div>
    <div>
      <div class="mt-4" v-if="rejectConfirmation">
        <CTextarea
          @input="validator(reason)"
          label="Reason"
          v-model="reason"
          placeholder="Give Reason"
          rows="5"
        />
      </div>
    </div>
    <template #header>
      <h6 class="modal-title">Verify Doctor</h6>
      <div v-if="doctor && doctor.registration_proof_image_url">
        <download-image
          :imgSrc="doctor.registration_proof_image_url"
          v-if="checkIfImage(doctor.registration_proof_image_url)"
        ></download-image>
      </div>
      <CButtonClose @click="closeModal()" />
    </template>
    <template #footer>
      <div class="w-100" v-if="approveConfirmation && fromDoctorLogs">
        <div class="w-100 d-flex justify-content-between">
          <p>Are you sure want to approve?</p>
          <div>
            <CButton
              variant="outline"
              color="danger"
              class="mr-2"
              @click="
                approveConfirmation = false;
                rejectApproveButton = true;
              "
            >No</CButton>
            <CButton color="success" @click="setStatus('APPROVED')">Yes</CButton>
          </div>
        </div>
      </div>
      <div v-if="rejectApproveButton && fromDoctorLogs">
        <CButton
          variant="outline"
          color="danger"
          class="mr-2"
          @click="rejectDoctor()"
          v-if="
            (doctor.current_document_status == 'PENDING' ||
              doctor.current_document_status == 'APPROVED' ||
              doctor.current_document_status == 'NOT_UPLOADED') &&
            permissions.includes('CAN_APPROVE_REJECT_DOCTOR_APPROVAL')
          "
        >Reject</CButton>
        <CButton
          color="success"
          @click="
            approveConfirmation = true;
            rejectApproveButton = false;
          "
          v-if="
            doctor.current_document_status == 'PENDING' &&
            permissions.includes('CAN_APPROVE_REJECT_DOCTOR_APPROVAL')
          "
        >Approve</CButton>
      </div>
      <div v-if="rejectConfirmation && fromDoctorLogs">
        <CButton
          variant="outline"
          color="danger"
          class="mr-2"
          @click="
            rejectConfirmation = false;
            rejectApproveButton = true;
          "
        >Cancel</CButton>
        <CButton :disabled="isValid" color="success" @click="setStatus('REJECT')">Submit</CButton>
      </div>
    </template>
  </CModal>
</template>
<script>
import config from "@/config.js";
import Swal from "sweetalert2";
const Image = () => import("@/components/image.vue");
const downloadImage = () => import("@/components/downloadImage.vue");
const Pdf = () => import("@/components/pdf.vue");
import { mapGetters } from "vuex";
export default {
  components: {
    "image-view": Image,
    "pdf-component": Pdf,
    downloadImage
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  data() {
    return {
      isValid: true,
      showModal: false,
      doctor: {},
      approveConfirmation: false,
      rejectApproveButton: true,
      rejectConfirmation: false,
      reason: "",
      fromDoctorLogs: true,
      doctorObj: {}
    };
  },
  methods: {
    validator(val) {
      if (/^[^-\s][a-zA-Z0-9_\s-]*$/g.test(val)) {
        this.isValid = false;
      } else {
        this.isValid = true;
      }
    },
    closeModal() {
      this.showModal = false;
      this.$emit("showDoctorLogModal", {
        doctor: this.doctorObj
      });
    },
    checkIfImage(str) {
      if (str.split(".").pop() !== "pdf") return true;
      return false;
    },
    viewModal(doctor, fromDoctorLogs = true, doctorObj) {
      this.doctor = doctor;
      this.fromDoctorLogs = fromDoctorLogs;
      this.showModal = true;
      this.approveConfirmation = false;
      this.rejectApproveButton = true;
      this.rejectConfirmation = false;
      this.doctorObj = doctorObj;
    },
    cancelApprovation() {
      alert("cancelApprovation");
    },
    approved() {
      alert("approved");
    },
    rejectDoctor() {
      this.rejectConfirmation = true;
      this.rejectApproveButton = false;
    },
    cancelRejectReason() {},
    setStatus(status) {
      let url = `${config.BASE_URL}api/v2/admin/doctor/document/verification/set-status`;
      let payload = {
        status: status,
        doctor_id: this.doctor.doctor_id._id,
        reason: this.reason
      };
      this.$http.post(url, payload).then(res => {
        if (res.body.status) {
          Swal.fire(
            `Doctor ${
              status.toLowerCase() == "reject" ? "Rejected" : "Approved"
            } Successfully`
          );
        } else {
          Swal.fire(res.body.message);
        }
        this.showModal = false;
        this.$emit("refreshList");
      });
    }
  },

  watch: {
    showModal: function(newVal) {
      if (newVal === true) {
        this.reason = "";
      }
    }
  }
};
</script>